function NewWorkspaceController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.startDate = ctrl.workspace.start_date;
    // Always set end date to 1.1.2038 (Unix time 2145916800)
    ctrl.endDate = 2145916800000;

    ctrl.optionsMenu = {
      startDateOpened: false,
      endDateOpened: false,
      openStartDatePicker: function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = true;
        ctrl.optionsMenu.endDateOpened = false;
      },
      openEndDatePicker: function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = false;
        ctrl.optionsMenu.endDateOpened = true;
      },
      datePickerFormat: 'dd.MM.yyyy',
      dateOptions: {
        startingDay: 1,
        showWeeks: false,
      },
    };    
  };

  ctrl.cancel = () => {
    ctrl.onCancel();
  };

  ctrl.submit = () => {
    // Always set end date to 1.1.2038 (Unix time 2145916800)
    ctrl.workspace.end_date = 2145916800000;
    ctrl.onSubmit({
      $event: {
        mode: ctrl.mode,
        workspace: ctrl.workspace
      },
    });
  };
}

angular
  .module('pis-tool.module')
  .controller('NewWorkspaceController', NewWorkspaceController);
